'use client';

import { Label as LabelPrimitive } from 'radix-ui';
import * as React from 'react';
import { cn } from '@/lib/utils';
function Label({
  className,
  required,
  children,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & {
  required?: boolean;
}) {
  return <LabelPrimitive.Root data-slot="label" className={cn('flex items-center gap-1 text-sm leading-none font-medium group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50', className)} {...props} data-sentry-element="LabelPrimitive.Root" data-sentry-component="Label" data-sentry-source-file="label.tsx">
      {children}
      {required && <span className="text-destructive">*</span>}
    </LabelPrimitive.Root>;
}
export { Label };